import styled from 'styled-components';

import { color, media, spacing, typography } from '~/theme';

export const RootContainer = styled.div``;

export const HintExpanderLabelWrapper = styled.button`
    background: transparent;
    border: none;
    color: ${color.palette.systemBlue};
    cursor: pointer;
    display: flex;
    font-family: ${typography.fontPrimary};
    font-size: 1rem;
    margin-top: -${spacing.spacing6};
    margin-bottom: ${spacing.spacing6};
    padding: ${spacing.spacing2} ${spacing.spacing1};
    position: relative;
    text-align: left;
    -webkit-appearance: none;

    &:hover {
        color: ${color.palette.systemMidBlue};
    }

    &:focus {
        color: ${color.palette.systemMidBlue};
        box-shadow: 0 0 0 4px ${color.palette.systemFocusBlue};
        outline: 4px solid transparent;
        transition: box-shadow 0.1s ease-in-out;
    }

    &:active {
        color: ${color.palette.systemDarkBlue};
    }
`;

export const HintExpanderLabelIcon = styled.span`
    height: auto;
    position: absolute;
    top: 5px;
`;

export const HintExpanderLabelText = styled.span`
    margin-left: calc(${spacing.spacing5} + ${spacing.spacing1});
`;

export const HintExpanderContent = styled.div`
    display: none;

    &[aria-hidden='false'] {
        display: block;
    }

    img {
        width: 100%;
    }

    figure {
        margin: ${spacing.spacing0};
    }

    @media ${media.small} {
        img {
            max-width: 352px;
        }

        figcaption {
            max-width: 362px;
        }
    }
`;

export const TextTypeHint = styled.p`
    display: block;
    padding: ${spacing.spacing4} ${spacing.spacing4} ${spacing.spacing4}
        calc(${spacing.spacing4} + ${spacing.spacing1});
    margin-left: ${spacing.spacing3};
    line-height: ${typography.lineHeight16};
    word-break: normal;
    word-wrap: break-word;
    color: ${color.palette.greyscale80};
    background-color: ${color.palette.greyscale5};
    border-left: ${spacing.spacing1} solid ${color.palette.greyscale20};
    max-width: 537px;
`;

export default {
    HintExpanderLabelWrapper,
    HintExpanderLabelIcon,
    HintExpanderLabelText,
    HintExpanderContent,
    TextTypeHint,
};
